import { createContext } from "react";
import correctorAndProducerStore from "./CorrectorAndProducerStore";

export const storesContext = createContext({
  correctorAndProducerStore,
});
